import { render } from "./TheShowAnswerPopup.vue?vue&type=template&id=efb80840&scoped=true"
import script from "./TheShowAnswerPopup.vue?vue&type=script&lang=js"
export * from "./TheShowAnswerPopup.vue?vue&type=script&lang=js"

import "./TheShowAnswerPopup.vue?vue&type=style&index=0&id=efb80840&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efb80840"]])

export default __exports__